


























































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { DataTablePagination } from '@/types/_'

@Component
export default class FinanceiroTabelaRegrasValoresFixos extends Vue {
  deleteRegraDeCalculo: boolean = false
  searchProfissional: any = ''
  loadingProfissionalFilter: boolean = false
  searchPrestador: any = ''
  loadingPrestadorFilter: boolean = false
  ignoreNextPrestadorSearch: boolean = false
  shouldProcessPaginationUpdate: boolean = true
  filterDebounced = _.debounce(() => this.executeFilter(), 300)

  profissionaisDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getProfissionais({ nome: param, campo: 'filtroValorFixo' }), 500)
  prestadoresDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getPrestadoresRepasse({ filtro: param, limite: 20, campo: 'filtroValorFixo' }), 500)

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get regrasDeCalculo() { return this.getRegrasDeCalculoStore.regrasValorFixo }

  loadRegrasDeCalculo: boolean = false
  get loadingRegrasDeCalculo() { return this.loadRegrasDeCalculo }
  set loadingRegrasDeCalculo(value: boolean) { this.loadRegrasDeCalculo = value }

  get showModalRegraValoresFixosIncluir() { return this.getRegrasDeCalculoStore.modal.valoresFixosIncluir }
  set showModalRegraValoresFixosIncluir(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'valoresFixosIncluir', value }) }

  get showModalDelete() { return this.deleteRegraDeCalculo }
  set showModalDelete(value: boolean) { this.deleteRegraDeCalculo = value }

  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }
  
  get prestadores() { return this.getRegrasDeCalculoStore.prestadoresFiltroValorFixo }

  get fontePagadora() {
    return this.getRegrasDeCalculoStore.fontePagadoraField
  }

  set fontePagadora(value: string) {
    this.getRegrasDeCalculoStore.setFontePagadoraField(value)
  }

  get prestador() {
    return this.getRegrasDeCalculoStore.prestadorIdSearch
  }

  set prestador(value: string) {
    this.getRegrasDeCalculoStore.setPrestadorIdSearch(value)
  }

  get selectedProfissionalExecutante(){
    return this.getRegrasDeCalculoStore.profissionalExecutanteIdSearch
  }

  set selectedProfissionalExecutante(value: any){
    this.getRegrasDeCalculoStore.setProfissionalExecutanteIdSearch(value)
  }

  get profissionaisExecutantes() {
    return this.getRegrasDeCalculoStore.profissionaisExecutantesFiltroValorFixo
  }

  get paginacaoRegrasDeCalculo() { return this.getRegrasDeCalculoStore.paginacaoRegrasValorFixo }

  regrasDeCalculoHeaders = [
    { text: 'Fonte Pagadora', value: 'fontePagadoraNome', sortable: false },
    { text: 'Prestador', value: 'prestadorNome', sortable: false },
    { text: 'Profissional', value: 'profissionalNome', sortable: false },
    { text: 'Tipo', value: 'tipo', sortable: false },
    { text: 'Ações', value: '', align: 'center', sortable: false },
  ]

  loadingEditarRegraDeCalculo = ''
  loadingDeleteCalculo: boolean = false

  displayDateAndHours(value: any) {
    if (!value) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  editarRegraDeCalculo(item: any) {
    this.loadingEditarRegraDeCalculo = item.id
    this.getRegrasDeCalculoStore.setModeModalRegraValoresFixos('EDIT')
    this.getRegrasDeCalculoStore.setRegraValorFixoItem(item)
    this.showModalRegraValoresFixosIncluir = true
    this.loadingEditarRegraDeCalculo = ''
  }

  openModalDelete(id: string) {
    this.getRegrasDeCalculoStore.setRegraValorFixoId(id)
    this.showModalDelete = true
  }

  async deleteRegraCalculoValorFixo() {
    this.loadingDeleteCalculo = true
    const request = await this.getRegrasDeCalculoStore.deleteRegraCalculoValorFixo()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeleteCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: 'Regra de cálculo excluída com sucesso!',
      icon: 'check',
      color: '#43A047',
    })
    this.showModalDelete = false
    this.loadingDeleteCalculo = false
  }

  regrasDeCalculoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegrasValorFixo(param), 700)

  async updatePaginationRegrasDeCalculo(pagination: DataTablePagination) {
    if (!this.shouldProcessPaginationUpdate) return
    this.regrasDeCalculoDebounced(pagination)
  }

  executeFilter() {
    this.shouldProcessPaginationUpdate = false
    this.loadingRegrasDeCalculo = true
    
    const pagination: DataTablePagination = {
      ...this.paginacaoRegrasDeCalculo,
      page: 1
    }
    
    this.getRegrasDeCalculoStore.setPaginacaoRegrasValorFixo(pagination)
    this.getRegrasDeCalculoStore.getRegrasValorFixo(pagination).then(() => {
      this.loadingRegrasDeCalculo = false
      this.$nextTick(() => {
        this.shouldProcessPaginationUpdate = true
      })
    })
  }

  async filterResults() {
    this.filterDebounced()
  }

  beforeDestroy() {
    this.getRegrasDeCalculoStore.clearRegrasDeCalculo()
    this.getRegrasDeCalculoStore.clearRegraDeCalculo()
    this.getRegrasDeCalculoStore.clearTabelasPreco()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoContratos()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoOperadoras()
    this.getRegrasDeCalculoStore.clearRegraDeCalculoProcedimentosDescartar()
  }

  async created(){
    await this.getRegrasDeCalculoStore.getPrestadoresRepasse({limite: 20, campo: 'filtroValorFixo'})
  }

  @Watch('searchPrestador')
  async onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.length < 3){
      this.getRegrasDeCalculoStore.setPrestadoresFiltroValorFixo([])
      return
    }

    this.loadingPrestadorFilter = true
    if(this.prestadoresDebounced) await this.prestadoresDebounced(val)
    this.loadingPrestadorFilter = false
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
  }

  @Watch('fontePagadora')
  onFontePagadoraChanged() {
    this.filterResults()
  }

  @Watch('prestador')
  onPrestadorChanged() {
    this.filterResults()
  }

  onProfissionalExecutanteChanged() {
    this.filterResults()
  }

  @Watch('searchProfissional')
  async onSearchProfissionalChanged(val: string) {
    if (!val || val.length < 3){
      this.getRegrasDeCalculoStore.setProfissionaisExecutantesFiltroValorFixo([])
      return
    }
      
    this.loadingProfissionalFilter = true
    if(this.profissionaisDebounced) await this.profissionaisDebounced(val)
    this.loadingProfissionalFilter = false
  }

  @Watch('showModalRegraValoresFixosIncluir')
  onShowModalRegraValoresFixosIncluirChange(value: boolean) {
    if (!value) {
      const currentPagination = this.paginacaoRegrasDeCalculo
      const pagination: DataTablePagination = {
        page: currentPagination.page,
        sortBy: currentPagination.sortBy,
        descending: currentPagination.descending,
        rowsPerPage: currentPagination.rowsPerPage,
        totalItems: currentPagination.totalItems,
        rowsPerPageItems: currentPagination.rowsPerPageItems,
      }
      this.updatePaginationRegrasDeCalculo(pagination)
    }
  }
}
